module.exports = __webpack_public_path__ + "static/freecards-dd1eb04a0eeaf4702057224921bce519.png";